/* eslint-disable semi,semi-style */
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Tween from 'rc-tween-one'
import platforms from '../../config'
import style from './index.module.scss'

const Developer = () => {
  // useEffect(() => {
  //   Omega.trackEvent('am_b_open_developer_sw', '能源开放平台-充电开发中心页', {
  //     host: location.hostname,
  //   });
  // }, []);
  return <React.Fragment>
    <h3 className={style.intro}>请选择您需要接入的平台</h3>

    <Tween
      animation={[
        { translateY: '15px', duration: 200, ease: 'easeInOutSine' },
        { y: 0, opacity: 1 }
      ]}
      style={{ opacity: 0 }}
      className={style.platformWrapper}
    >
      <ul className={style.platform}>
        {platforms.filter(it => !it.hidden).map((it, i) => (
          <li key={i}>
            <Link to={it.path} >
              <img src={`https://view.didistatic.com/static/dcms/548313280_medium_${it.imgIndex ? it.imgIndex : i + 1}.png`} />
              <h2>{it.title}</h2>
              <p>{it.desc}</p>
            </Link>
          </li>
        ))}
      </ul>
    </Tween>
  </React.Fragment>
}

export default Developer;